import { render, staticRenderFns } from "./SinglePurchaseOverseasStockings.vue?vue&type=template&id=77e80b48&"
import script from "./SinglePurchaseOverseasStockings.vue?vue&type=script&lang=js&"
export * from "./SinglePurchaseOverseasStockings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SinglePurchaseOverseasStockings.vue"
export default component.exports